<div class="row g-3">
  @for (i of [1,2,3]; track $index) {
  <div class="col-12">
    <div class="card m-0">
      <div class="card-body p-3">
        <!-- Header skeleton -->
        <div class="d-flex justify-content-between align-items-start mb-3">
          <div class="flex-grow-1 me-3">
            <div class="d-flex align-items-baseline">
              <div class="placeholder-glow">
                <span class="placeholder col-2 me-2"></span>
                <span class="placeholder col-4"></span>
              </div>
            </div>
          </div>
          <div class="d-flex align-items-center justify-content-end gap-2">
            <div class="placeholder-glow">
              <span
                class="placeholder col-3"
                style="width: 32px; height: 32px"
              ></span>
            </div>
          </div>
        </div>

        <!-- Content skeleton -->
        <div class="card-content">
          @for (j of [1,2,3,4]; track $index) {
          <div
            class="row align-items-center py-1 border-bottom border-opacity-50"
          >
            <div class="col-6">
              <div class="placeholder-glow">
                <span class="placeholder col-8"></span>
              </div>
            </div>
            <div class="col-6 text-end">
              <div class="placeholder-glow">
                <span class="placeholder col-6"></span>
              </div>
            </div>
          </div>
          }
        </div>

        <!-- Buttons skeleton -->
        <div class="text-center mt-3">
          <div class="d-flex gap-2 justify-content-center">
            <div class="placeholder-glow">
              <span class="placeholder col-4" style="height: 32px"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  }
</div>